export default (fileName: string) => fileName.replace(/\.[^.]*$/,'');